import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

function Register() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: 'analyst'
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error(t('auth.passwordsNotMatch'));
      return;
    }

    setLoading(true);
    const { confirmPassword, ...userData } = formData;

    const success = await register(userData);
    if (success) {
      navigate('/login');
    }
    setLoading(false);
  };

  return (
    <div className="form-container">
      <h2>{t('auth.registerTitle')}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>{t('auth.username')}</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>{t('auth.email')}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>{t('auth.password')}</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>{t('auth.confirmPassword')}</label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? t('auth.registering') : t('auth.registerButton')}
        </button>
      </form>
      <p style={{ marginTop: 'var(--spacing-lg)', textAlign: 'center' }}>
        {t('auth.alreadyHaveAccount')} <Link to="/login">{t('auth.loginHere')}</Link>
      </p>
    </div>
  );
}

export default Register;